import React from 'react';
import cn from 'classnames';
import styles from './TableBody.module.scss';

const TableBody = ({ className, ...props }) => {
  return <tbody {...props} className={cn(styles.tableBody, className)} />;
};

export default TableBody;
